import { createContext, useContext } from "react";
import { UserManager } from "oidc-client-ts";

interface OidcContextValue {
    userManager: UserManager | undefined;
}

export const OidcContext = createContext<OidcContextValue>({ userManager: undefined });

export const useOidc = () => useContext(OidcContext);
